import LogoDefault from "@/assets/regions/WF-Logo.png";
import LogoHigh from "@/assets/regions/CGL-logo.png";
import { RiskLevel } from "@/model/RiskLevel";
const WalthamForestDefault = {
    rawCopy: "For alcohol advice and support in Waltham Forest, call CGL on 0203 826 9600",
    logoLink: ""
};
const WalthamForestHighRisk = {
    rawCopy: "For alcohol advice and support in Waltham Forest, call CGL on 0203 826 9600",
    logoLink: ""
};
const WalthamForestIncreasingRisk = {
    rawCopy: "For Increasing Risk scores we recommend that you cut down your drinking. Click here to <u>book a free online appointment</u> with DrinkCoach.",
    logoLink: "https://drinkcoach.bookinglive.com/book/add/p/18"
};
export default {
    name: "Waltham Forest",
    logo: {
        file: LogoDefault,
        width: 600,
        height: 350
    },
    logoHigh: {
        file: LogoHigh,
        width: 439,
        height: 223
    },
    hasFreeAppointments: true,
    showServiceInfoOnResultsSummaryPage: true,
    regions: [
        "Cann Hall",
        "Cathall",
        "Chapel End",
        "Chingford Green",
        "Endlebury",
        "Forest",
        "Grove Green",
        "Hale End and Highams Park",
        "Hatch Lane",
        "High Street",
        "Higham Hill",
        "Hoe Street",
        "Larkswood",
        "Lea Bridge",
        "Leyton",
        "Leytonstone",
        "Markhouse",
        "Valley",
        "William Morris",
        "Wood Street"
    ],
    bannerInfo: {
        default: WalthamForestDefault,
        [RiskLevel.Lower]: WalthamForestDefault,
        [RiskLevel.Increasing]: WalthamForestIncreasingRisk,
        [RiskLevel.Higher]: WalthamForestDefault,
        [RiskLevel.High]: WalthamForestHighRisk
    },
    clinics: [
        {
            name: "CGL Waltham Forest",
            isPrimaryProvider: true,
            alwaysShowInResults: true,
            tagline: "(Adults aged 18+)",
            description: "Contact ${name}: ${phone}</a>",
            other_info: "Due to COVID we are operating an appointment only service. These appointments can be delivered by phone, online and face-to-face, with evening time slots available." +
                "<br><br><strong><a href='tel:02038269600'>Call</a> or <a href='mailto:cgl.walthamforest@cgl.org.uk'>email</a> to arrange an appointment. Alternatively, fill in our online <a href='https://www.changegrowlive.org/drug-alcohol-service-waltham-forest/referrals' target='_blank'>Referral Form</a> and a CGL worker will be in touch.</strong><br><br>If you are worried about a friend or family member's drinking, we can provide advice and support - contact us to find out more.<br><br>",
            phone: ["0203 826 9600"],
            times: [
                {
                    title: "Phone lines open:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            email: "cgl.walthamforest@cgl.org.uk",
            address: "1 Beulah Road, Walthamstow, London, E17 9LG",
            location: { lat: 51.5815806, lng: -0.012249 },
            website: "https://www.changegrowlive.org/drug-alcohol-service-waltham-forest"
        },
        {
            name: "CGL Young People’s Service",
            isPrimaryProvider: true,
            alwaysShowInResults: false,
            times: [
                {
                    title: "Phone lines open:",
                    times: {
                        monday: [{ start: 900, end: 1700 }],
                        tuesday: [{ start: 900, end: 1700 }],
                        wednesday: [{ start: 900, end: 1700 }],
                        thursday: [{ start: 900, end: 1700 }],
                        friday: [{ start: 900, end: 1700 }]
                    }
                }
            ],
            other_info: "<strong><a href='tel:02034041098'>Call</a> or <a href='mailto:walthamforestyp@cgl.org.uk'>email</a> to arrange an appointment.</strong>",
            tagline: "(For young people aged under 18)",
            address: "313 Billet Road, Higham Hill, Waltham Forest, E17 5PX",
            phone: ["0203 404 1098"],
            email: "walthamforestyp@cgl.org.uk",
            location: { lat: 51.5978241, lng: -0.0430898 },
            website: "https://www.changegrowlive.org/young-peoples-drug-alcohol-service-waltham-forest/"
        },
        {
            name: "DrinkCoach Online Appointment",
            tagline: "(Adults aged 18+)",
            other_info: "Waltham Forest Council have funded a limited number of free online coaching sessions for Waltham Forest residents. Offer valid for the first 20 residents that refer to the service (up to 4 free sessions each). <br><br><strong><a href='https://drinkcoach.bookinglive.com/book/add/p/18' target='_blank'>Book here</a></strong><br><br>",
            alwaysShowInResults: true,
            showAtRiskLevel: [RiskLevel.Higher]
        }
    ]
};
//# sourceMappingURL=WalthamForest.js.map